// 100% client-side redaction. Runs in browser memory before any payload is sent.

const CCY = "USD|EUR|GBP|HKD|CNY|RMB|JPY|SGD|AUD|CAD|CHF|AED|INR|KRW|MYR|THB|NZD|SEK|NOK|DKK";

export function maskAmounts(text = "") {
  return String(text)
    // Currency code + figure, e.g. "USD 120,000.00", "HKD120000,00"
    .replace(new RegExp(`\\b(?:${CCY})\\s?[\\d][\\d.,]*`, "gi"), "[REDACTED_AMOUNT]")
    // Tolerances / percentages, e.g. "+/- 5%", "±10%", "5 %"
    .replace(/[+\-±]?\s?\d+(?:\.\d+)?\s?%/g, "[REDACTED_AMOUNT]")
    // Amount label lines, e.g. "Amount: 120,000.00", "Unit Price 12.50"
    .replace(/((?:Amount|Sum|Unit\s*Price|Total|Value|Credit\s*Amount)\s*[:：]?\s*)([\d][\d.,]*)/gi, "$1[REDACTED_AMOUNT]");
}

export function maskParties(text = "") {
  return String(text)
    // SWIFT fields: 50 (applicant), 59 (beneficiary), 51/52/53 (banks) — mask until next tag.
    .replace(/(:(?:50|59|51|52|53)[A-Z]?:)([\s\S]*?)(?=\n:\d{2}[A-Z]?:|$)/g, "$1 [REDACTED_PARTY]")
    // Labelled parties in manual LC terms.
    .replace(/((?:Applicant|Beneficiary|Issuing\s*Bank|Advising\s*Bank|Account\s*Party|Opener|Accountee)\s*[:：]\s*)(.+)/gi, "$1[REDACTED_PARTY]");
}

export function maskAccounts(text = "") {
  return String(text)
    // IBAN, e.g. "GB29NWBK60161331926819"
    .replace(/\b[A-Z]{2}\d{2}[A-Z0-9]{10,30}\b/g, "[REDACTED_ACCOUNT]")
    // Keyword-anchored account / SWIFT / BIC values (avoids masking ordinary words).
    .replace(/((?:Account(?:\s*(?:No\.?|Number))?|A\/C|IBAN|SWIFT(?:\s*Code)?|BIC)\s*[:：#]?\s*)([A-Za-z0-9][A-Za-z0-9\- ]{5,})/gi, "$1[REDACTED_ACCOUNT]");
}

export const MASKERS = { amounts: maskAmounts, parties: maskParties, accounts: maskAccounts };
